import { useState, useCallback } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

type ConfirmProps = {
	open?: boolean;
	onConfirm: () => void;
	closeConfirm: () => void;
	title: string;
	children: React.ReactNode;
};

export const useConfirm = () => {
	const [isOpen, setIsOpen] = useState(false);

	const openConfirm = useCallback(() => {
		setIsOpen(true);
	}, []);

	const closeConfirm = useCallback(() => {
		setIsOpen(false);
	}, []);

	return {
		Confirm,
		confirmProps: {
			open: isOpen,
			openConfirm,
			closeConfirm,
		},
	};
};

const Confirm = (props: ConfirmProps) => {
	const { open = false, title, children, onConfirm, closeConfirm } = props;

	return (
		<Dialog open={open} fullWidth={true} maxWidth={'md'}>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>{children}</DialogContent>

			<DialogActions>
				<Button variant="outlined" color="primary" onClick={onConfirm}>
					<span>Confirm</span>
				</Button>
				<Button onClick={closeConfirm} autoFocus color="error" variant="outlined">
					Cancel
				</Button>
			</DialogActions>
		</Dialog>
	);
};
